import { observable } from "mobx";
import { api_adm } from "../../api";
import { toast } from "react-toastify";

export class _TabelaSimplesStore {

  obs = observable({
    tabelasimples: [] as any,
  })

  async handleGetFaixas(params: any) {
    try {
      let resp = await api_adm.post(`/api/admin/tabelasimples/index`, params);

      this.obs.tabelasimples = [];
      this.obs.tabelasimples = resp.data[0] || []

    } catch (ex) {
      toast.error("Erro ao carregar Tabela Simples!", {});
    }
  }

  async handleUpdateValue(faixa: string, tipo: string, id: string, campo: string, valor: number) {
    try {
      let params = {
        faixa: faixa, id: id, campo: campo, valor: valor, tipo: tipo
      }

      let resp = await api_adm.post(`/api/admin/tabelasimples/update`, params);

      if (resp.data.ok) {
        toast.success("Valor atualizado com sucesso!", {});
        return true

      } else {
        toast.error("Não foi possível atualizar valor, tente novamente mais tarde!", {});
        return false
      }

    } catch (ex) {
      toast.error("Erro ao atualizar valor, tente novamente mais tarde!", {});
      return false
    }
  }

  async handleCreate(params: any) {
    try {

      let resp = await api_adm.post(`/api/admin/tabelasimples/create`, params);

      if (resp.data.ok) {
        toast.success("Tabela criada com sucesso!", {});
        return true

      } else {
        toast.error("Não foi possível criar tabela, tente novamente mais tarde!", {});
        return false
      }

    } catch (ex) {
      toast.error("Erro ao criar tabela, tente novamente mais tarde!", {});
      return false
    }
  }

}

export const TabelaSimplesStore = new _TabelaSimplesStore();
